module.exports = __webpack_public_path__ + "img/canada-digestive-diseases-male.2f224758.png";